import Main from "../../layouts/Main";
import Card from "../../components/Card";
import Tab from "../../components/Tab";
import SalaryCutRecap from "./Recap/SalaryCutRecap";
import CashReceipt from "./CashReceipt/cashreceipt";
import Instalment from "./Instalment/instalment";
import BPJS from "./BPJS/bpjs";
import SalaryCutComplainWages from "./ComplainWages/complainwages";

const SalaryCutV2 = () => {
  const data = [
    {
      name: "Rekap",
      id: "#tab1",
      content: <SalaryCutRecap />,
    },
    {
      name: "Kasbon",
      id: "#tab2",
      content: <CashReceipt />,
    },
    {
      name: "Cicilan",
      id: "#tab3",
      content: <Instalment />,
    },
    {
      name: "BPJS",
      id: "#tab4",
      content: <BPJS />,
    },
    {
      name: "Upah Komplain",
      id: "#tab5",
      content: <SalaryCutComplainWages />,
    },
  ];

  return (
    <Main title="Pemotongan Upah">
      <Card col={"col-xl-12 col-lg-12"}>
        <Tab data={data} defaultId={data[0].id} defaultContent={data[0].content} />
      </Card>
    </Main>
  );
};

export default SalaryCutV2;
